import { Quote } from "lucide-react";

export const Testimonials = ({ t }) => {
  const items = t.results.items;

  return (
    <section id="results" data-testid="testimonials-section" className="overflow-hidden py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6">
        <div className="max-w-3xl">
          <p className="font-mono-num text-xs uppercase tracking-[0.3em] text-[#EAB308]">{t.results.eyebrow}</p>
          <h2 className="mt-4 text-4xl font-extrabold sm:text-5xl">{t.results.headline}</h2>
          <p className="mt-4 text-base text-gray-400 md:text-lg">{t.results.sub}</p>
        </div>
      </div>

      <div className="relative mt-16">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-[#0B0E11] to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-[#0B0E11] to-transparent" />
        <div
          data-testid="testimonials-scroll"
          className="overflow-x-auto overflow-y-hidden [-webkit-overflow-scrolling:touch] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
        >
          <div className="flex w-max cursor-grab gap-6 px-6 animate-marquee hover:[animation-play-state:paused] active:[animation-play-state:paused] active:cursor-grabbing">
            {[...items, ...items].map((p, i) => (
              <div
                key={i}
                data-testid={`testimonial-card-${i % items.length}`}
                className="w-[300px] shrink-0 overflow-hidden rounded-2xl border border-white/10 bg-[#0C1732] transition-[border-color,transform] duration-300 hover:-translate-y-1 hover:border-[#EAB308]/40"
              >
                <div className="h-[400px] overflow-hidden">
                  <img
                    src={p.img}
                    alt="GTA member result screenshot"
                    loading="lazy"
                    draggable="false"
                    className="h-full w-full object-cover object-top transition-transform duration-500 hover:scale-105"
                  />
                </div>
                <div className="flex items-start gap-3 p-5">
                  <Quote className="mt-0.5 h-4 w-4 shrink-0 text-[#EAB308]" />
                  <p className="text-xs leading-relaxed text-gray-300">{p.caption}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <p data-testid="testimonials-note" className="mx-auto mt-10 max-w-7xl px-6 text-xs italic text-gray-600">
        {t.results.note}
      </p>
    </section>
  );
};
